import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/services/app/app.service';
// import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { AdminService } from 'src/app/services/admin/admin.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from 'src/app/components/layout/spinner/spinner.component';

@Component({
  selector: 'app-logo-upload',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SpinnerComponent
  ],
  templateUrl: './app-logo.component.html',
  styleUrls: ['./app-logo.component.css']
})
export class AppLogoComponent {
  @Output() imageSelected = new EventEmitter<File | null>();
  @Input() id = 0;
  @Input() logo: string
  @Input() load = false
  @Input() productId = ''
  @Input() isProduct = false

  faXmark = ''

  image: File | null = null;
  imageSrc: string | ArrayBuffer | null = null;
  constructor(
    private AppService: AppService,
    private adminService: AdminService
  ) { }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer?.files.length > 0) {
      const file = event.dataTransfer.files[0];
      this.selectImage(file);
    }
  }

  // onFileChange(event: any) {
  //   if (event.target.files.length > 0) {
  //     const file = event.target.files[0];
  //     this.selectImage(file);
  //   }
  //   event.target.value = null;
  // }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (!file) return;
  
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
  
    if (!allowedTypes.includes(file.type)) {
      alert('Only PNG, JPG, JPEG, or WEBP images are allowed.');
      event.target.value = null;
      return;
    }
  
    this.selectImage(file);
    event.target.value = null;
  }

  onDragDropClick() {
    const fileInput = document.getElementById('image') as HTMLInputElement;
    fileInput.click();
  }

  selectImage(file: File) {
    this.clearImage(); // clear previous image if any
    this.image = file;

    this.previewImage(file);
    this.uploadImage(file); // upload the image immediately
  }

  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageSrc = reader.result;
    };
    reader.readAsDataURL(file);
  }

  clearImage() {
    this.image = null;
    this.imageSrc = null;
    this.imageSelected.emit(null);
  }

  uploadImage(file: File) {

    this.load = true
    const data = {
      appId: this.id, 
      userId: this.adminService.user.id,
      productId: this.productId,
    }

    this.AppService.uploadLogo(file, data).subscribe(
      (response: any) => {
        this.load = false
        console.log('Upload successful', response);
        this.imageSelected.emit(file); // emit the uploaded image
      },
      (error: any) => {
        this.load = false
        console.error('Upload error', error);
        this.clearImage(); // clear image if upload fails
      }
    );
  }
}